// extracted by mini-css-extract-plugin
export default {"container":"about_container__SUog4","links":"about_links__5wu3E","listDecoration":"about_listDecoration__j21F4","picture":"about_picture__bmvFq"};